import { useLocation } from 'react-router-dom';
import { Store } from '../types/vendor-menu';
import {
  HOME_PAGE_ROUTE,
  STORES_LIST_ROUTE,
  VIEW_CART_ROUTE,
  getStoreMenuRoute,
} from '../constants/routes';
import { VenueTypes } from '../pages/home/home';

/**
 * [Gets route for page where patron can add items or select vendors based on venue-type]
 * @param  {[string]} venueType [venue type]
 * @param  {[string]} store [Store object]
 * @param  {[string]} selectedVendorId [selected vendor/only vendor in dine-in]
 */
export const getEntryPointRoute = (
  venueType: string,
  store?: Store,
  selectedVendorId?: string,
  selectedMenuId?: string,
): string => {
        if ( store && location.pathname === VIEW_CART_ROUTE && selectedMenuId) {
          return getStoreMenuRoute(store.ownerID, store._id, selectedMenuId);
        }
        return STORES_LIST_ROUTE;
};
